import React, { useEffect, useRef } from "react";
import * as d3 from "d3";
import { useTheme } from "../../contexts/ThemeContext";

export const ProgressIndicator = ({ value, unavailableLabel = "No disponible" }) => {
  const theme = useTheme();
  const chartRef = useRef(null);
  const numericValue = value === null || value === undefined || Number.isNaN(Number(value))
    ? null
    : Math.max(0, Math.min(100, Number(value)));

  useEffect(() => {
    if (!chartRef.current || numericValue === null) return;

    const svg = d3.select(chartRef.current);
    svg.selectAll("*").remove();

    const size = 36;
    const strokeWidth = 6;
    const radius = (size - strokeWidth) / 2;
    const arc = d3.arc().innerRadius(radius - strokeWidth).outerRadius(radius);
    const pie = d3.pie().value((d) => d.value).sort(null);
    const data = [
      { label: "done", value: numericValue },
      { label: "pending", value: 100 - numericValue },
    ];
    const colors = d3.scaleOrdinal([
      theme.mode === "dark"
        ? theme.colors.backgroundPendienteLight
        : theme.colors.backgroundPendienteDark,
      theme.mode === "dark"
        ? theme.colors.backgroundCompletadoLight
        : theme.colors.backgroundCompletadoDark,
    ]);

    svg
      .attr("width", size)
      .attr("height", size)
      .append("g")
      .attr("transform", `translate(${size / 2},${size / 2})`)
      .selectAll("path")
      .data(pie(data))
      .join("path")
      .attr("d", arc)
      .attr("fill", (_, i) => colors(i));
  }, [numericValue, theme.mode, theme.colors]);

  if (numericValue === null) return <span>{unavailableLabel}</span>;

  const formattedPercent = numericValue > 0 && numericValue < 1
    ? numericValue.toFixed(1)
    : Math.floor(numericValue);

  return (
    <div className="flex items-center justify-center gap-2" title={`${formattedPercent}%`}>
      <svg ref={chartRef} aria-hidden="true" />
      <span>{formattedPercent}%</span>
    </div>
  );
};

export default ProgressIndicator;
